import { BillableEntity } from "../billing-new/billableEntity";
import {BillingDetail} from "./billingDetail";
import {DsoDetails} from './dsoDetails';

export class EParticipant{
    _id: number;
    _name: string;
    _activationRange: Date[]
    _userId: number;
    _operationId: number;
    _billingDetail: BillingDetail;
    _dsoDetails: DsoDetails;
    _billableEntity: BillableEntity;

    constructor(
        id: number,
        name: string,
        activationRange: Date[],
        userId: number,
        operationId: number,
        billingDetail: BillingDetail,
        dsoDetails: DsoDetails,
        billableEntity: BillableEntity
    ) {
        this._id = id;
        this._name = name;
        this._activationRange = activationRange;
        this._userId = userId;
        this._operationId = operationId;
        this._billingDetail = billingDetail;
        this._dsoDetails = dsoDetails;
        this._billableEntity = billableEntity;
    }

}
